(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hana-product-value"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hana-value]').forEach((calculator) => {
    const applicationsInput = calculator.querySelector('[data-hana-applications]');
    const serviceInput = calculator.querySelector('[data-hana-service-price]');
    const applicationsLabel = calculator.querySelector('[data-hana-applications-label]');
    const serviceLabel = calculator.querySelector('[data-hana-service-label]');
    const unitCost = calculator.querySelector('[data-hana-unit-cost]');
    const revenue = calculator.querySelector('[data-hana-revenue]');
    const share = calculator.querySelector('[data-hana-share]');
    const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

    const update = () => {
      const productPrice = Number(calculator.dataset.productPrice || 0) / 100;
      const applications = Math.max(Number(applicationsInput?.value || 1), 1);
      const servicePrice = Number(serviceInput?.value || 0) / 100;
      const potentialRevenue = servicePrice * applications;
      if (applicationsLabel) applicationsLabel.textContent = String(applications);
      if (serviceLabel) serviceLabel.textContent = currency.format(servicePrice);
      if (unitCost) unitCost.textContent = currency.format(productPrice / applications);
      if (revenue) revenue.textContent = currency.format(potentialRevenue);
      if (share) share.textContent = `${potentialRevenue > 0 ? ((productPrice / potentialRevenue) * 100).toFixed(1).replace('.', ',') : '0'}%`;
    };

    applicationsInput?.addEventListener('input', update);
    serviceInput?.addEventListener('input', update);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.variant?.price) return;
        calculator.dataset.productPrice = String(data.variant.price);
        update();
      });
    }
    update();
  });
  } catch(e) { console.error(e); }
})();

})();
